import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import laptopImg from "../../Assets/about.png";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              <strong className="purple">Martian</strong>
            </h1>
            <p>
            Martian is a Space technology company.
            </p>
            
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>
        <h1 className="project-heading">
          AI <strong className="purple">Control </strong>
        </h1>
        <p>
        We are inventing A.I. for Space system control.
        </p>

        <h1 className="project-heading">
          <strong className="purple">Machine</strong> Learning
        </h1>

        <p>
        We are developing machine learning technologies for Space applications.
        </p>

        <h1 className="project-heading">
          Autonomous <strong className="purple">Rockets </strong>
        </h1>

        <p>
          We are innovating in autonomous rocket technology.
        </p>
       
      </Container>
    </Container>
  );
}

export default About;
